<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="free-person"
			title="割当可能メンバー"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-flex xs10 class="mx-2">
						<v-text-field dark clearable height="23" v-model="filter_name" placeholder="名前で検索" color="white" single-line></v-text-field>
					</v-flex>
					<v-flex xs2 class="mx-2">
						<v-btn v-if="isFiltering" dark icon color="orange" v-on:click="onClickFiltering"><v-icon>filter_list</v-icon></v-btn>
						<v-btn v-else flat icon blue color="white" v-on:click="onClickFiltering"><v-icon>filter_list</v-icon></v-btn>
					</v-flex>
				</v-layout>
			</template>
			<template>
				<div class="row-group" v-for="free_person in filtered_free_persons" v-bind:key="free_person.member.code">
					<div class="row ma-2">
						<div class="name">{{ free_person.member.name }}</div>
						<div class="tel">連絡先: {{ free_person.member.tel }}</div>
						<GBClasses
							:items="free_person.member.classes"
							:max_width=300
							:all_show=true
						/>
					</div>
					<v-icon class="alert-icon" v-if="free_person.alert">error</v-icon>
				</div>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBClasses from './GBClasses';
import Util from '../classes/Util';

export default {
	name: 'GBRightPaneFreePerson',
	props: [
		"value",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBClasses,
	},
	data: function() {
		return {
			filter_name: '',
		};
	},
	methods: {
		onClose: function() {
			this.filter_name = '';
			this.$emit('close');
		},
		onClickFiltering: function() {
			this.$emit('show-member-filtering', false);
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filtered_free_persons: function() {
			if (this.value == null)
				return;
			let free_persons = this.$store.getters.freePersonsBySchedule(this.value.schedule);
			let ret = this.$store.getters.filteredMemberList(free_persons);
			return ret.filter((item) => {
				if (this.filter_name === null)
					return true;
				if (this.filter_name.length === 0)
					return true;
				return item.member.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
			});
		},
		isFiltering: function() {
			let memberFilter = this.$store.getters.memberFilter;
			return memberFilter && memberFilter.classes && memberFilter.classes.length > 0;
		},
	},
}
</script>
<style>
	.modal-window.free-person .row-group {
		position: relative;
		border-bottom: solid 1px #a9a9a9;
		padding-right: 12px;
	}
	.modal-window.free-person .name {
		font-size: 18px;
		word-wrap: break-word;
	}
	.modal-window.free-person .tel {
		font-size: 14px;
	}
	.modal-window.free-person .modal-header-filter {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
<style scoped>
	.alert-icon {
		position: absolute;
		right: 15px;
		top: 0;
		opacity: .6;
		cursor: pointer;
		pointer-events: none;
		color: darkorange;
	}
</style>
